import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Admin/Integration/ZohoIntegration/ZohoHome';

const ZohoHome = () => ((orgContainer(InnerComponent)));
export default ZohoHome;
